import gql from 'graphql-tag';

const GET_ALL_SOP = gql`
  query {
    getAllSOPs {
      sopId
      name
      description
      emailTemplateList {
        id
        name
        content
        subject
        templateType
      }
      taskTemplates {
        taskOrder
        taskTemplate {
          taskTemplateId
          title
          description
          estimatedTime
          technician {
            userId
            firstName
            lastName
            email
          }
          techGroup {
            groupId
            name
            description
          }
        }
      }
      approverList {
        userTypeRole {
          roleId
          name
        }
        placeHolder
        type
      }
    }
  }
`;

const GET_ALL_SOP_FOR_DROPDOWN = gql`
  query {
    getAllSOPs {
      sopId
      name
    }
  }
`;

const GET_SOP_PLACEHOLDERFIELDS = gql`
  query {
    getSOPApproverPlaceholderFields {
      requesterFields
      technicianFields
      ticketFields
    }
  }
`;

const GET_NOTIFICATION_TEMPLATEPLACEHOLDERS = gql`
  query {
    getNotificationTemplatePlaceholderFields {
      requesterFields
      technicianFields
      ticketFields
    }
  }
`;

const GET_NOTIFICATION_TEMPLATE = gql`
  query($templateId: ID!) {
    getNotificationTemplate(templateId: $templateId) {
      id
      name
      subject
      content
      placeholdersUsed
      to
      cc
      bcc
      activated
      # senderNameType
      # senderNameValue
      # emailSignatureType
      templateType
      templateSubtype
      attachmentList {
        fileName
      }
    }
  }
`;

const CREATE_SOP = gql`
  mutation(
    $sopId: ID
    $name: String
    $description: String
    $approverList: [RecipientInput]
    $addEmailTemplateList: [NotificationTemplateInput]
    $addTaskTemplateList: [SOPTaskTemplateInput]
  ) {
    createSOP(
      input: {
        sopId: $sopId
        name: $name
        description: $description
        approverList: $approverList
        addEmailTemplateList: $addEmailTemplateList
        addTaskTemplates: $addTaskTemplateList
      }
    ) {
      sopId
      name
      description
      emailTemplateList {
        name
        id
      }
      taskTemplateList {
        title
        description
        taskTemplateId
      }
    }
  }
`;

const UPDATE_SOP = gql`
  mutation(
    $sopId: ID!
    $name: String
    $description: String
    $approverList: [RecipientInput]
    $addEmailTemplateList: [NotificationTemplateInput]
    $addTaskTemplateList: [SOPTaskTemplateInput]
    $removeEmailTemplateList: [NotificationTemplateInput]
    $removeTaskTemplateList: [SOPTaskTemplateInput]
    $updateTaskTemplates: [SOPTaskTemplateInput]
  ) {
    updateSOP(
      sopId: $sopId
      input: {
        name: $name
        description: $description
        approverList: $approverList
        addEmailTemplateList: $addEmailTemplateList
        addTaskTemplates: $addTaskTemplateList
        removeEmailTemplateList: $removeEmailTemplateList
        removeTaskTemplates: $removeTaskTemplateList
        updateTaskTemplates: $updateTaskTemplates
      }
    ) {
      sopId
      name
      description
      emailTemplateList {
        name
        id
      }
      taskTemplateList {
        title
        description
        taskTemplateId
      }
    }
  }
`;

const DELETE_SOP = gql`
  mutation($id: ID!) {
    deleteSOP(sopId: $id)
  }
`;

const UPDATE_NOTIFICATION_TEMPLATE = gql`
  mutation(
    $templateId: ID!
    $name: String
    $content: String
    $subject: String
  ) {
    updateNotificationTemplate(
      templateId: $templateId
      input: { name: $name, content: $content, subject: $subject }
    ) {
      name
      id
      content
    }
  }
`;

export {
  UPDATE_SOP,
  UPDATE_NOTIFICATION_TEMPLATE,
  GET_NOTIFICATION_TEMPLATE,
  CREATE_SOP,
  GET_SOP_PLACEHOLDERFIELDS,
  GET_ALL_SOP,
  DELETE_SOP,
  GET_NOTIFICATION_TEMPLATEPLACEHOLDERS,
  GET_ALL_SOP_FOR_DROPDOWN
};
